export default __webpack_public_path__ + "static/media/analisis_de_datos_act-fisica.6360d331.png";